var map = {
	"./collection.de-CH.json": 1592,
	"./collection.de-DE.json": 1593,
	"./collection.en-CA.json": 1594,
	"./collection.en-GB.json": 1595,
	"./collection.en-IN.json": 1596,
	"./collection.en-ME.json": 1597,
	"./collection.en-US.json": 1598,
	"./collection.es-EM.json": 1599,
	"./collection.es-ES.json": 1600,
	"./collection.fr-BE.json": 1601,
	"./collection.fr-CA.json": 1602,
	"./collection.fr-CH.json": 1603,
	"./collection.nl-BE.json": 1604,
	"./collection.nl-NL.json": 1605,
	"./collection.pl-PL.json": 1606,
	"./collection.pt-BR.json": 1607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1591;